import throttle from 'lodash/throttle';
import { SmoothScrollToElement } from "../../modules/SmoothScrollToElement";

export module SectionScroll02Module {
  export class Service {
    private notSectionClassName = 'is-not-section'
    private SCROLL_UP = 1;
    private SCROLL_DOWN = 2;
    private SCROLL_NONE = 0;
    private SCROLL_THRESHOLD = 3;
    private EVENT_INTERVAL = 10;
    private container: HTMLDivElement | null = null;
    private containerBuffer: HTMLDivElement | null = null;
    private isScroll = false;
    private maxPageNumber = 0;
    private currentPageNumber = 0;
    private wheelEventMouse = {
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
    }
    private touchStartY: number | null = null
    private isActive: boolean = false
    private wheelEventTime = new Date().getTime()

    constructor() {
      this.container = document.querySelector('.SectioinScroll02');
      this.containerBuffer = document.querySelector('.StyledSectioinScroll02__buffer');
      if (this.container && this.containerBuffer) {
        document.addEventListener('readCompleteAction', () => {
          this.setEvent();
        })
      }
    }

    public setEvent() {
      if (!this.container) return
      // ページ数を取得
      const sections = Array.from(this.container.children).filter((child) => {
        return !child.classList.contains(this.notSectionClassName)
      })
      this.maxPageNumber = sections.length - 1

      // css制御 style 設定のためコンテナにいることがわかるようにクラスを付与
      // <html> タグを取得
      const html = document.getElementsByTagName('html')[0]
      // クラスを付与
      html.classList.add('hasSectionScroll')
      document.body.classList.add('hasSectionScroll')

      // すべてのメソッドをクラスのインスタンスにバインド
      this.OnResize = this.OnResize.bind(this);
      this.OnTouchStart = this.OnTouchStart.bind(this);
      this.OnKeyDown = this.OnKeyDown.bind(this);
      this.OnWheel = this.OnWheel.bind(this);
      this.OnTouchMove = this.OnTouchMove.bind(this);
      this.OnScroll = this.OnScroll.bind(this);
      this.OnHashChange = this.OnHashChange.bind(this);

      // イベントリスナーの追加
      this.addEventListeners();

      // アンカー対応
      const self = this;
      setTimeout(() => {
        // 操作をアクティブにする
        self.isActive = true

        // hash を取得
        const hash = window.location.hash
        if (hash) {
          // hash が存在する場合はアンカー対応
          this.Anchor(hash.replace('#', ''))
        } else {
          // hash が存在しない場合はページ番号を更新
          window.scrollTo(0, -100)
          document.body.dataset.sectionNumber = String(1)
        }
      }, 2000);

      // 画面が横向きになったらbodyにクラスを付与
      const OnOrientationChange = () => {
        // 横向きのときはangleが90または-90になる
        if (window.screen.orientation.angle === 0) {
          document.body.classList.remove('isLandscape')
        } else {
          document.body.classList.add('isLandscape')
        }
      }
      OnOrientationChange()
      // "change"イベントを使用してスクリーンのオリエンテーションの変更を検出
      window.addEventListener('orientationchange', OnOrientationChange)

      // body .is-loaded が付与されたら this.container の 最初の子要素の data-section-active-flg 属性が存在するのを取得し、is-active クラスを付与
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const targetElement = mutation.target as HTMLElement;
            if (targetElement.tagName === 'BODY' && targetElement.classList.contains('is-loaded')) {
              this.activateSection();
            }
          }
        });
      });
      observer.observe(document.body, { attributes: true });
    }

    private addEventListeners() {
      // スクロール制御
      window.addEventListener('resize', this.OnResize);
      window.addEventListener('touchstart', this.OnTouchStart, { passive: false });
      window.addEventListener('keydown', this.OnKeyDown);

      // スクロール監視
      window.addEventListener('wheel', this.OnWheel, { passive: false });
      window.addEventListener('touchend', this.OnTouchMove, { passive: false });

      // ローディング中などでスクロールを一時的に止める
      window.addEventListener('wheel', this.OnScroll, { passive: false });
      window.addEventListener('touchmove', this.OnScroll, { passive: false });
      window.addEventListener('scroll', this.OnScroll, { passive: false });

      // ハッシュ変更
      window.addEventListener('hashchange', this.OnHashChange);
    }

    private removeEventListeners() {
      // スクロール制御
      window.removeEventListener('resize', this.OnResize);
      window.removeEventListener('touchstart', this.OnTouchStart);
      window.removeEventListener('keydown', this.OnKeyDown);

      // スクロール監視
      window.removeEventListener('wheel', this.OnWheel);
      window.removeEventListener('touchend', this.OnTouchMove);

      // ローディング中などでスクロールを一時的に止める
      window.removeEventListener('wheel', this.OnScroll);
      window.removeEventListener('touchmove', this.OnScroll);
      window.removeEventListener('scroll', this.OnScroll);
    }

    // body .is-loaded が付与されたら this.container の 最初の子要素の data-section-active-flg 属性が存在するのを取得し、is-active クラスを付与
    private activateSection() {
      if (!this.container) return;
      // this.container の最初の子要素を取得
      const firstSection = this.container.firstElementChild as HTMLElement;
      const firstSectionWithFlag = firstSection.querySelectorAll('[data-section-active-flg]');
      setTimeout(() => {
        firstSectionWithFlag.forEach((section) => {
          section.classList.add('is-active');
        });
      }, 800);
    }

    /** functions */
    // 現在のスクロール位置を取得
    private GetScriollTop() {
      return new Promise<number>((resolve) => {
        setTimeout(() => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
          resolve(scrollTop)
        }, 10)
      })
    }

    // 現在ブラウザ内にコンテナーを表示しているか判定
    private IsShowContainer() {
      if (!this.container) return false

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      const pageHeight = window.innerHeight
      const containerTop = this.container.offsetTop
      const containerBottom = containerTop + this.container.offsetHeight
      const isShow = (containerTop <= scrollTop + pageHeight) && (scrollTop < containerBottom)
      if (isShow) {
        if (!document.body.classList.contains('isShowSectionScroll')) {
          document.body.classList.add('isShowSectionScroll')
        }
      } else {
        if (document.body.classList.contains('isShowSectionScroll')) {
          document.body.classList.remove('isShowSectionScroll')
        }
      }
      return isShow
    }

    // ページ番号を更新
    private UpdatePageNumber() {
      // bodyに.is-modal-openがある場合は処理しない
      if (document.body.classList.contains('is-modal-open')) return

      this.IsShowContainer()
    }

    // コンテナ内の対象要素を取得
    private GetSelections() {
      if (!this.container) return []
      const sections = Array.from(this.container.children).filter((child) => {
        return !child.classList.contains(this.notSectionClassName)
      })
      this.maxPageNumber = sections.length - 1
      return sections
    }

    // コンテナ外の次の要素を取得
    private GetNextElement() {
      if (!this.container) return null
      return this.container.nextElementSibling as HTMLElement
    }

    // コンテナ外へのページ移動 (コンテナの上は存在しない想定)
    private MovePageOut() {
      // body に .is-loaded がない場合は処理しない
      if (!document.body.classList.contains('is-loaded')) return
      // スクロール中は処理しない
      if (this.isScroll) return
      // セクション対象要素を取得
      const nextElement = this.GetNextElement()
      // nextElement が存在しない場合は処理しない
      if (!nextElement) return
      // maxPageNumber が存在しない場合は処理しない
      if (!this.maxPageNumber) return
      // body に .is-modal-open がある場合は処理しない
      if (document.body.classList.contains('is-modal-open')) return

      this.isScroll = true
      const sectionNumber = this.maxPageNumber + 1 + 1
      SmoothScrollToElement(
        nextElement,
        () => {
          this.isScroll = false
          this.UpdatePageNumber()
          // body data-section-number 属性を更新
          this.currentPageNumber = sectionNumber - 2
          document.body.dataset.sectionNumber = String(sectionNumber)
          //dispatch({ type: 'SET_SECTION_NUMBER', payload: sectionNumber })

          // this.container の 子孫要素の data-section-active-flg 属性が存在するのを取得し、is-active クラスを付与
          const sections = Array.from(this.container!.children).filter((child) => {
            return !child.classList.contains(this.notSectionClassName)
          })
          sections.forEach((section, index) => {
            const sectionActiveFlg = section.querySelectorAll('[data-section-active-flg]')
            sectionActiveFlg.forEach((element) => {
              element.classList.add('is-active')
            })
          })

          // this.container の次の要素の data-section-active-flg 属性が存在するのを取得し、is-active クラスを削除
          console.log('nextElement', nextElement);
          const nextSection = nextElement.querySelectorAll('[data-section-active-flg]')
          nextSection.forEach((element) => {
            element.classList.add('is-active')
          })

          // 現在のページ番号までのすべてのクラスを付与します
          for (let i = 0; i <= this.maxPageNumber; i++) {
            document.body.classList.add(`--section-number-${i}`);
          }

          // nextPageElement と nextPageElement より前にある要素の .StyledUiTextAnimation に対して、playAnimation イベントを発火
          const textAnimation = nextElement.querySelectorAll('.StyledUiTextAnimation')
          textAnimation.forEach((element) => {
            const event = new Event('playAnimation')
            element.dispatchEvent(event)
          })

        },
        undefined,
        1,
      )
    }

    // コンテナ内のページ移動
    private MovePage(pageNumberArg: number, forceUpdateFlag?: boolean) {
      // body に .is-loaded がない場合は処理しない
      if (!document.body.classList.contains('is-loaded')) {
        console.log('MovePage: not loaded');
        return;
      }
      // スクロール中は処理しない
      if (this.isScroll) {
        console.log('MovePage: is scroll');
        return;
      }
      // container が存在しない場合は処理しない
      if (!this.container) {
        console.log('MovePage: not container');
        return;
      }
      // maxPageNumber が存在しない場合は処理しない
      if (!this.maxPageNumber) {
        console.log('MovePage: not max page number');
        return;
      }
      // body に .is-modal-open がある場合は処理しない
      if (document.body.classList.contains('is-modal-open')) {
        console.log('MovePage: is modal open');
        return;
      }
      // 強制更新フラグがない場合は、コンテナが表示されていない場合は処理しない
      if (forceUpdateFlag !== true && !this.IsShowContainer()) {
        console.log('MovePage: not show container');
        return;
      }
      // 
      let pageNumber = pageNumberArg
      if (this.currentPageNumber > this.maxPageNumber) {
        pageNumber = this.maxPageNumber
      }
      // body に .is-modal-open がある場合は処理しない
      if (document.body.classList.contains('is-modal-open')) {
        console.log('MovePage: is modal open');
        return;
      }
      // pageNumber が 0 未満の場合は処理しない
      if (pageNumber < 0) {
        console.log('MovePage: page number < 0');
        return;
      }
      // pageNumber が currentPageNumber と同じ場合は処理しない
      if (pageNumber === this.currentPageNumber) {
        console.log('MovePage: page number === current page number');
        return;
      }
      // pageNumber が maxPageNumber より大きい場合はMovePageOutを実行
      if (pageNumber >= this.maxPageNumber) {
        console.log('MovePage: page number > max page number');
        this.MovePageOut()
        return
      }

      const selections = this.GetSelections()
      const nextPageElement = selections[pageNumber] as HTMLElement
      if (!nextPageElement) {
        console.log('MovePage: not next page element');
        return
      }
      this.isScroll = true
      this.currentPageNumber = pageNumber
      SmoothScrollToElement(nextPageElement, () => {
        this.UpdatePageNumber()
        // body data-section-number 属性を更新
        document.body.dataset.sectionNumber = String(pageNumber + 1)
        //dispatch({ type: 'SET_SECTION_NUMBER', payload: pageNumber + 1 })
        this.isScroll = false

        // nextPageElement と nextPageElement より前にある要素の data-section-active-flg 属性が存在するのを取得し、is-active クラスを付与
        const sections = Array.from(this.container!.children).filter((child) => {
          return !child.classList.contains(this.notSectionClassName)
        })
        sections.forEach((section, index) => {
          if (index <= pageNumber) {
            const sectionActiveFlg = section.querySelectorAll('[data-section-active-flg]')
            sectionActiveFlg.forEach((element) => {
              element.classList.add('is-active')
            })
          } else {
            const sectionActiveFlg = section.querySelectorAll('[data-section-active-flg]')
            sectionActiveFlg.forEach((element) => {
              element.classList.remove('is-active')
            })
          }
        })

        // nextPageElement より後にある要素の data-section-active-flg 属性が存在するのを取得し、is-active クラスを削除
        sections.forEach((section, index) => {
          if (index > pageNumber) {
            const sectionActiveFlg = section.querySelectorAll('[data-section-active-flg]')
            sectionActiveFlg.forEach((element) => {
              element.classList.remove('is-active')
            })
          }
        })

        // nextPageElement と nextPageElement より前にある要素の .StyledUiTextAnimation に対して、playAnimation イベントを発火
        sections.forEach((section, index) => {
          if (index <= pageNumber) {
            const textAnimation = section.querySelectorAll('.StyledUiTextAnimation')
            textAnimation.forEach((element) => {
              const event = new Event('playAnimation')
              element.dispatchEvent(event)
            })
          }
        })

        // nextPageElement より後にある要素の .StyledUiTextAnimation に対して、resetAnimation イベントを発火
        sections.forEach((section, index) => {
          if (index > pageNumber) {
            const textAnimation = section.querySelectorAll('.StyledUiTextAnimation')
            textAnimation.forEach((element) => {
              const event = new Event('resetAnimation')
              element.dispatchEvent(event)
            })
          }
        })

        const nextElement = this.GetNextElement()
        if (nextElement) {
          // this.container の次の要素の data-section-active-flg 属性が存在するのを取得し、is-active クラスを削除
          const nextSection = nextElement.querySelectorAll('[data-section-active-flg]')
          nextSection.forEach((element) => {
            element.classList.remove('is-active')
          })

          // nextPageElement と nextPageElement より前にある要素の .StyledUiTextAnimation に対して、resetAnimation イベントを発火
          const textAnimation = nextElement.querySelectorAll('.StyledUiTextAnimation')
          textAnimation.forEach((element) => {
            const event = new Event('resetAnimation')
            element.dispatchEvent(event)
          })
        }

        // 現在のページ番号までのすべてのクラスを付与します
        for (let i = 0; i <= this.currentPageNumber; i++) {
          document.body.classList.add(`--section-number-${i}`);
        }

        // 現在のページ番号よりも大きい番号のクラスを削除します
        for (let i = this.currentPageNumber + 1; i <= this.maxPageNumber; i++) {
          document.body.classList.remove(`--section-number-${i}`);
        }

      })
    }

    // 上下どちらにスクロールしたか判定 wheel
    // SCROLL_UP: 上
    // SCROLL_DOWN: 下
    // SCROLL_NONE: なし
    private GetWheelDirection(event: WheelEvent) {
      if (Math.abs(event.deltaY) < this.SCROLL_THRESHOLD) {
        return this.SCROLL_NONE
      }
      if (event.deltaY < 0) {
        this.wheelEventMouse = {
          clientX: event.clientX,
          clientY: event.clientY,
          pageX: event.pageX,
          pageY: event.pageY,
        }
        return this.SCROLL_UP
      }
      if (event.deltaY > 0) {
        this.wheelEventMouse = {
          clientX: event.clientX,
          clientY: event.clientY,
          pageX: event.pageX,
          pageY: event.pageY,
        }
        return this.SCROLL_DOWN
      }
      return this.SCROLL_NONE
    }

    // 上下どちらにスクロールしたか判定 touch
    // SCROLL_UP: 上
    // SCROLL_DOWN: 下
    // SCROLL_NONE: なし
    private GetTouchDirection(event: TouchEvent) {
      if (event.changedTouches.length === 0) {
        return this.SCROLL_NONE
      }
      if (!this.touchStartY) {
        return this.SCROLL_NONE
      }
      const touch = event.changedTouches[0]
      if (Math.abs(touch.pageY - this.touchStartY) < this.SCROLL_THRESHOLD) {
        return this.SCROLL_NONE
      }
      if (touch.pageY < this.touchStartY) {
        return this.SCROLL_DOWN
      }
      if (touch.pageY > this.touchStartY) {
        return this.SCROLL_UP
      }
      return this.SCROLL_NONE
    }

    // 現在のページの要素を取得
    private GetCurrentPageElement() {
      if (!this.container) return null
      if (this.currentPageNumber === null) return null
      const sections = Array.from(this.container.children).filter((child) => {
        return !child.classList.contains(this.notSectionClassName)
      })
      if (sections.length === 0) return null
      if (sections[this.currentPageNumber] === undefined) return null
      return sections[this.currentPageNumber] as HTMLElement
    }

    // 制御関連の event handler
    // 上下のキーボタンでのページ移動を禁止
    private OnKeyDown(event: KeyboardEvent) {
      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.preventDefault()
      }
    }

    // スクロール禁止 wheelevent / touchmove / scroll
    private OnScroll(event: Event) {
      if (!this.isActive) {
        event.preventDefault()
        console.log('OnScroll: not active', this.isActive);
        return
      }
      // body に .is-loaded がない場合は処理しない
      if (!document.body.classList.contains('is-loaded')) {
        event.preventDefault()
        console.log('OnScroll: not loaded');
        return
      }
      // スクロール中は処理しない
      if (!this.IsShowContainer()) {
        console.log('OnScroll: not show container');

        return
      }
      // body に .is-modal-open がある場合は処理しない
      if (document.body.classList.contains('is-modal-open')) {
        console.log('OnScroll: is modal open');
        return
      }
      event.preventDefault()
      console.log('OnScroll: prevent default');

    }

    // 親要素にリンクがあるか判定
    private hasAncestorLink(el: HTMLElement | null) {
      while (el) {
        if (el.tagName.toLowerCase() === 'a') {
          return true
        }
        el = el.parentElement
      }
      return false
    }

    // スクロール禁止 touchstart
    private OnTouchStart(event: TouchEvent) {
      if (!this.IsShowContainer()) {
        return
      }
      // body に .is-modal-open がある場合は処理しない
      if (document.body.classList.contains('is-modal-open')) {
        return
      }
      // リンクをタップした場合はスクロール禁止しない 
      if (event.target instanceof HTMLAnchorElement) {
        this.touchStartY = event.touches[0].pageY
        return
      }
      if (this.hasAncestorLink(event.target as HTMLElement)) {
        this.touchStartY = event.touches[0].pageY
        return
      }
      event.preventDefault()
      this.touchStartY = event.touches[0].pageY
    }

    // 現在のページのトップとブラウザのスクロール位置がずれている場合は調整
    private async OnScrollToCurrentPage() {
      if (!this.container) return
      if (this.currentPageNumber === null) return
      if (!this.IsShowContainer()) return
      if (this.isScroll) return

      const scrollTop = await this.GetScriollTop()
      const currentPageElement = this.GetCurrentPageElement()
      if (!currentPageElement) return
      if (scrollTop === currentPageElement.offsetTop) return
      this.isScroll = true
      SmoothScrollToElement(currentPageElement, () => {
        this.isScroll = false
      })
    }

    // リサイズイベント
    private OnResize() {
      if (!this.container) return
      if (this.currentPageNumber === null) return
      if (!this.IsShowContainer()) return

      // リサイズで現在のページのトップとブラウザのスクロール位置がずれている場合は調整
      this.OnScrollToCurrentPage()
    }

    // 実際の処理
    // スクロールイベント (wheel)
    private OnWheel = throttle((event: WheelEvent) => {
      // body に .is-loaded がない場合は処理しない
      if (!document.body.classList.contains('is-loaded')) {
        console.log('OnWheel: not loaded');
        return;

      }
      if (!this.isActive) {
        console.log('OnWheel: not active');
        return
      }
      if (!this.container) {
        console.log('OnWheel: not container');
        return
      }
      if (this.isScroll) {
        console.log('OnWheel: is scroll');
        return
      }
      if (!this.IsShowContainer()) {
        console.log('OnWheel: not show container');
        return
      }
      // body に .is-modal-open がある場合は処理しない
      if (document.body.classList.contains('is-modal-open')) {
        console.log('OnWheel: is modal open');
        return
      }
      if (document.documentElement.scrollTop >= this.container.offsetHeight) {
        console.log('OnWheel: scroll top');
        return
      }
      if (this.currentPageNumber === null) {
        console.log('OnWheel: not current page number');
        this.UpdatePageNumber()
        return
      }
      if (this.wheelEventTime + this.EVENT_INTERVAL >= new Date().getTime()) {
        console.log('OnWheel: wheel event time');
        this.wheelEventTime = new Date().getTime()
        return
      }
      if (!event.clientX && !event.clientY) {
        console.log('OnWheel: not client x y');
        return
      }

      const direction = this.GetWheelDirection(event)
      if (direction === this.SCROLL_UP || direction === this.SCROLL_DOWN) {
        this.wheelEventTime = new Date().getTime()
        if (direction === this.SCROLL_UP) {
          console.log('OnWheel: scroll up');
          this.MovePage(this.currentPageNumber - 1)
        } else if (direction === this.SCROLL_DOWN) {
          console.log('OnWheel: scroll down');
          this.MovePage(this.currentPageNumber + 1)
        }
      }
    },
      this.EVENT_INTERVAL,
      {
        // 初回は leading: true で実行
        leading: true,
        // 最後の実行は trailing: false で実行
        trailing: true
      })

    // スクロールイベント (touch)
    private OnTouchMove = throttle(async (event: TouchEvent) => {
      // body に .is-loaded がない場合は処理しない
      if (!document.body.classList.contains('is-loaded')) return
      if (!this.isActive) {
        return
      }
      if (!this.container) return
      if (!this.containerBuffer) return
      if (!this.maxPageNumber) return
      if (!this.IsShowContainer()) { }
      // body に .is-modal-open がある場合は処理しない
      if (document.body.classList.contains('is-modal-open')) return
      if (document.documentElement.scrollTop >= this.container.offsetHeight) {
        return
      }
      if (this.currentPageNumber === null) {
        this.UpdatePageNumber()
        return
      }

      // スクロール位置が containerBuffer のtop - (containerBuffer height / 2) 以下の場合はページ移動
      const containerBufferTop = this.containerBuffer.offsetTop
      const containerBufferHeight = this.containerBuffer.offsetHeight
      const scrollTop = await this.GetScriollTop()
      if (this.currentPageNumber > this.maxPageNumber && scrollTop < containerBufferTop - (containerBufferHeight / 2)) {
        this.MovePage(this.currentPageNumber - 1)
        return
      } else {
        const direction = this.GetTouchDirection(event)
        if (direction === this.SCROLL_UP) {
          this.MovePage(this.currentPageNumber - 1)
        } else if (direction === this.SCROLL_DOWN) {
          this.MovePage(this.currentPageNumber + 1)
        }
      }
    },
      this.EVENT_INTERVAL,
      {
        // 初回は leading: true で実行
        leading: true,
        // 最後の実行は trailing: false で実行
        trailing: true
      })

    // アンカー対応対応
    private Anchor(id: string) {
      if (this.container === null) return
      if (!id) return
      const target = this.container.querySelector(`[id="${id}"]`)
      if (target === null) return

      const sections = this.GetSelections()
      const targetSection = sections.indexOf(target)
      if (targetSection === -1) return

      //MovePage(targetSection, true)
      const selections = this.GetSelections()
      const nextPageElement = selections[targetSection] as HTMLElement
      if (!nextPageElement) return
      this.isScroll = true
      this.currentPageNumber = targetSection
      SmoothScrollToElement(nextPageElement, () => {
        this.UpdatePageNumber()
        //dispatch({ type: 'SET_SECTION_NUMBER', payload: targetSection + 1 })
        document.body.dataset.sectionNumber = String(targetSection + 1)
        this.isScroll = false
        this.UpdatePageNumber()
        // body data-section-number 属性を更新
        document.body.dataset.sectionNumber = String(targetSection + 1)
        //dispatch({ type: 'SET_SECTION_NUMBER', payload: pageNumber + 1 })
        this.isScroll = false

        // nextPageElement と nextPageElement より前にある要素の data-section-active-flg 属性が存在するのを取得し、is-active クラスを付与
        const sections = Array.from(this.container!.children).filter((child) => {
          return !child.classList.contains(this.notSectionClassName)
        })
        sections.forEach((section, index) => {
          if (index <= targetSection) {
            const sectionActiveFlg = section.querySelectorAll('[data-section-active-flg]')
            sectionActiveFlg.forEach((element) => {
              element.classList.add('is-active')
            })
          } else {
            const sectionActiveFlg = section.querySelectorAll('[data-section-active-flg]')
            sectionActiveFlg.forEach((element) => {
              element.classList.remove('is-active')
            })
          }
        })

        // nextPageElement より後にある要素の data-section-active-flg 属性が存在するのを取得し、is-active クラスを削除
        sections.forEach((section, index) => {
          if (index > targetSection) {
            const sectionActiveFlg = section.querySelectorAll('[data-section-active-flg]')
            sectionActiveFlg.forEach((element) => {
              element.classList.remove('is-active')
            })
          }
        })

        // nextPageElement と nextPageElement より前にある要素の .StyledUiTextAnimation に対して、playAnimation イベントを発火
        sections.forEach((section, index) => {
          if (index <= targetSection) {
            const textAnimation = section.querySelectorAll('.StyledUiTextAnimation')
            textAnimation.forEach((element) => {
              const event = new Event('playAnimation')
              element.dispatchEvent(event)
            })
          }
        })

        // nextPageElement より後にある要素の .StyledUiTextAnimation に対して、resetAnimation イベントを発火
        sections.forEach((section, index) => {
          if (index > targetSection) {
            const textAnimation = section.querySelectorAll('.StyledUiTextAnimation')
            textAnimation.forEach((element) => {
              const event = new Event('resetAnimation')
              element.dispatchEvent(event)
            })
          }
        })

        // this.container の次の要素の data-section-active-flg 属性が存在するのを取得し、is-active クラスを削除
        const nextElement = this.GetNextElement()
        if (nextElement) {
          const nextSection = nextElement.querySelectorAll('[data-section-active-flg]')
          nextSection.forEach((element) => {
            element.classList.remove('is-active')
          })
        }

        // 現在のページ番号までのすべてのクラスを付与します
        for (let i = 0; i <= this.currentPageNumber; i++) {
          document.body.classList.add(`--section-number-${i}`);
        }

        // 現在のページ番号よりも大きい番号のクラスを削除します
        for (let i = this.currentPageNumber + 1; i <= this.maxPageNumber; i++) {
          document.body.classList.remove(`--section-number-${i}`);
        }
      })

      //dispatch({ type: 'SET_ANCHOR_ID', payload: null })
      document.body.dataset.anchorId = ''
    }

    //
    private OnHashChange() {
      const hash = window.location.hash
      if (hash) {
        this.Anchor(hash.replace('#', ''))
      }
    }

  }
}
